import React, { FC } from 'react';
import { Button, Modal } from 'src/components';
import { defineMessages, useIntl } from 'react-intl';
import * as S from './styles';

const msgs = defineMessages({
  header: { id: 'skill_framework_description_header' },
  textDelete: { id: 'resetprogress_delete_language_bodycopy' },
  textReset: { id: 'resetprogress_reset_language_bodycopy' },
  delete: { id: 'resetprogress_delete_language_cta' },
  reset: { id: 'resetprogress_reset_language_cta' },
  cancel: { id: 'scenarioDetails_markAllAsKnown_confirmation_cancel' },
});

export const ConfirmationPopup: FC<{
  isOpen: boolean;
  flag: string;
  type: 'reset' | 'delete';
  onAction: () => void;
  onClose: () => void;
}> = ({ isOpen, flag, type, onAction, onClose }) => {
  const intl = useIntl();

  return (
    <Modal
      darkCloseIcon
      handleClose={onClose}
      shouldCloseOnEsc
      isOpen={isOpen}
      shouldCloseOnOutsideClick
    >
      <S.ModalContent>
        <S.FlagImageWrapper>
          <S.FlagImage src={flag} alt="" />
        </S.FlagImageWrapper>
        <S.ModalHeader data-testid="ActionsPopup-header">
          {intl.formatMessage(msgs.header)}
        </S.ModalHeader>
        <S.TextWrapper>
          {intl.formatMessage(type === 'reset' ? msgs.textReset : msgs.textDelete)}
        </S.TextWrapper>
        <S.ButtonsWrapper>
          <Button
            buttonSize="medium"
            buttonType="primary"
            wide
            onClick={onAction}
            data-testid={`${type}-language-btn`}
          >
            {intl.formatMessage(type === 'reset' ? msgs.reset : msgs.delete)}
          </Button>

          <Button buttonSize="medium" buttonType="secondary" wide onClick={onClose}>
            {intl.formatMessage(msgs.cancel)}
          </Button>
        </S.ButtonsWrapper>
      </S.ModalContent>
    </Modal>
  );
};
